import React, { FunctionComponent } from "react"
import { Paginate, PaginateProps } from "../../components/Paginate"
import { useSelectedPrompts } from "./hooks/useSelectedPrompts"

interface PromptsTablePaginateProps extends PaginateProps {}
export const PromptsTablePaginate: FunctionComponent<PromptsTablePaginateProps> = props => {
    const { unselectAll } = useSelectedPrompts()
    const { callback, totalPages, currentPage } = props

    function onCallback(newPage: number) {
        unselectAll()
        callback(newPage)
    }
    return <Paginate callback={onCallback} totalPages={totalPages} currentPage={currentPage} />
}
